import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getApplicationSettings } from 'src/modules/applications/slices';
import { useCampaignConfigService } from '../services';
import {
  setLoading,
  setUsedConfigs,
} from '../slices';

export const useUsedCampaignConfigLoader = () => {
  const dispatch = useDispatch();
  const { getUsedCampaignConfigs } = useCampaignConfigService();
  const applicationSettings = useSelector(getApplicationSettings);

  const loadUsedCampaignConfigs = useCallback(async () => {
    try {
      dispatch(setLoading(true));
      const response = await getUsedCampaignConfigs(applicationSettings?.applicationId);
      dispatch(setUsedConfigs(response));
    } catch (error) {
      console.error('Failed to load used campaign configs:', error);
    } finally {
      dispatch(setLoading(false));
    }
  }, [
    dispatch,
    getUsedCampaignConfigs,
    applicationSettings?.applicationId,
  ]);

  return {
    loadUsedCampaignConfigs,
  };
};

